export const changeArrayElementValues = <T extends {}>(id: string, getData: (el: T) => T) => {
  return (prev) => prev?.map((el) => (el.id === id ? getData(el) : el))
}

export const addSuffixToNumber = (n: number): string => {
  if (n > 3 && n < 21) return 'th'
  switch (n % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const roundNumber = (num: number, dec: number): number => Math.round(num * 10 ** dec) / 10 ** dec

export const addEllipsisToText = (text: string, limit: number): string =>
  text.length > limit ? `${text.substring(0, limit)}...` : text
